<template>
  <div class="MainAgendaList">
    <van-loading
      class="mainLoading"
      v-show="mainLoading"
      type="spinner"
      color="#409eff"
      size=".7rem"
      text-size=".4rem"
      >加载中...</van-loading
    >
    <!-- 顶部按钮 -->
    <div class="buttonBox" :style="{ width: isMobile ? '' : '40%' }" v-if="!mainLoading">
      <a
        @click.stop="
          $router.push(
            `/subpages/agendaSearch?event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${$route.query.currentDate}&mode=list&listDate=${$route.query.listDate}&listPlace=${$route.query.listPlace}&listGroup=${$route.query.listGroup}`
          )
        ">
        <span>日程名称搜索</span>
        <img src="@/assets/image/search.png" alt="" />
      </a>
      <a
      v-if="$route.query.event_id != 1310"
       @click.stop="$router.push(`/subpages/guestSearch?event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${$route.query.currentDate}&mode=list&listDate=${$route.query.listDate}&listPlace=${$route.query.listPlace}&listGroup=${$route.query.listGroup}`)"
        >
        <span>嘉宾列表搜索</span>
        <img src="@/assets/image/search.png" alt="" />
      </a>
    </div>

    <!-- 筛选区域 -->
    <div class="screenBox" v-show="!mainLoading">
      <div class="screenItem">
        <span class="name">日期</span>
        <ul ref="dateUl">
          <li
            ref="dateLi"
            :class="{ Selected: dateSelectedValue == '' }"
            @click="screenClick('dateSelectedValue', 0)">
            全部
          </li>
          <li
            :class="{ Selected: dateSelectedValue == item }"
            @click="screenClick('dateSelectedValue', item)"
            v-for="item in agendaConfig.agenda_date"
            v-show="!dateSelectedValueHide || dateSelectedValueHideList.includes(item)"
            :key="item">
            {{ item }}
          </li>
        </ul>
        <div class="StowBtn" v-show="dateUl === 0" @click="StowOpenClick(0, 'dateUl')">收起∧</div>
        <div class="openBtn" v-show="dateUl === 1" @click="StowOpenClick(1, 'dateUl')">展开∨</div>
      </div>
      <div class="screenItem">
        <span class="name">会场</span>
        <ul ref="placeUl">
          <li
            ref="placeLi"
            :class="{ Selected: placeSelectedValue == '' }"
            @click="screenClick('placeSelectedValue', 0)">
            全部
          </li>
          <li
            ref=""
            :class="{ Selected: placeSelectedValue == item }"
            @click="screenClick('placeSelectedValue', item)"
            v-for="item in agendaConfig.agenda_place"
            v-show="!placeSelectedValueHide || placeSelectedValueHideList.includes(item)"
            :key="item">
            {{ item }}
          </li>
        </ul>
        <div class="StowBtn" v-show="placeUl === 0" @click="StowOpenClick(0, 'placeUl')">收起∧</div>
        <div class="openBtn" v-show="placeUl === 1" @click="StowOpenClick(1, 'placeUl')">展开∨</div>
      </div>
      <div class="screenItem">
        <span class="name">学科</span>
        <ul ref="groupUl">
          <li
            ref="groupLi"
            :class="{ Selected: groupSelectedValue == '' }"
            @click="screenClick('groupSelectedValue', 0)">
            全部
          </li>
          <li
            :class="{ Selected: groupSelectedValue == item }"
            @click="screenClick('groupSelectedValue', item)"
            v-for="(item, index) in agendaConfig.agenda_group"
            v-show="!groupSelectedValueHide || groupSelectedValueHideList.includes(item)"
            :key="index">
            {{ item }}
          </li>
        </ul>
        <div class="StowBtn" v-show="groupUl === 0" @click="StowOpenClick(0, 'groupUl')">收起∧</div>
        <div class="openBtn" v-show="groupUl === 1" @click="StowOpenClick(1, 'groupUl')">展开∨</div>
      </div>
    </div>
    <!-- 分割线 -->
    <div class="splitLine" v-if="!mainLoading"></div>

    <!-- 日程列表 -->
    <div class="scheduleListBox" v-if="!mainLoading">
      <van-loading
        v-show="listLoading"
        class="listLoading"
        type="spinner"
        color="#409eff"
        size=".7rem"
        text-size=".4rem"
        >加载中...</van-loading
      >
      <dl v-for="item in agendaList" :key="item.Date" style="margin-top: 0.3rem">
        <!-- 日期 -->
        <dt class="date">{{ item.Date }}</dt>
        <dd v-for="i in item.Agendas" :key="i.Place">
          <!-- 会场 -->
          <div class="place">{{ i.Place }}</div>
          <!-- 会场项目 -->
          <ul class="mainSchedule" v-for="i2 in i.Agendas" :key="i2.id">
            <li class="mainScheduleItem">
              <div class="itemBox">
                <!-- 右侧直播按钮 -->
                <div class="toLive-btn" v-show="i2.live_url" @click="toLive(i2.live_url)">
                  <img class="icon" src="@/assets/image/play-icon.png" alt="" />
                  <span class="toLiveText">前往直播</span>
                </div>
                <!-- 左侧 -->
                <div class="left">
                  <!-- 左上 -->
                  <div class="left-top">
                    <span class="time"
                      >{{ i2.start_time + '-' + i2.end_time }}&nbsp; | &nbsp;
                    </span>
                    <span class="theme">{{ i2.agenda_title }}</span>
                  </div>
                  <!-- 左下 -->
                  <div class="left-bottom">
                    <ul>
                      <!-- 职务 -->
                      <li v-for="i3 in i2.guests_data" :key="i3.identity">
                        <span class="title">{{ i3.identity }}：</span>
                        <!-- 人员 -->
                        <div class="guestList">
                          <span
                            class="guest"
                            :style="{
                              display: !isMobile ? 'inline-block' : 'flex',
                              marginLeft: !isMobile ? '.2rem' : '',
                            }"
                            v-for="i4 in i3.childrenList"
                            :key="i4.guest_id"
                            @click="
                              $router.push(
                                `/subpages/guestAgenda?agenda_id=${$route.query.agenda_id}&event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${$route.query.currentDate}&id=${i4.guest_id}&mode=list`
                              )
                            "
                            ><span class="name" style="white-space: nowrap">{{ i4.name }} </span>
                            <span style="margin: 0 5px" v-show="i4.company">|</span>
                            <span class="Company" v-show="i4.company">{{ i4.company }}</span></span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <!-- 手机子日程 -->
            <template v-if="isMobile">
              <dl class="subAgenda" v-for="(i4, i) in i2.sub_schedule" :key="i4.id">
                <dt>
                  <div class="time">{{ i4.start_time }}-{{ i4.end_time }}</div>
                  <div class="theme">{{ i4.agenda_title }}</div>
                </dt>
                <dl>
                  <!-- 人员信息 -->
                  <div class="people">
                    <!-- 人员模块 -->
                    <peopleItem
                      mode="list"
                      :name="i5.name"
                      :position="i5.company"
                      :agenda_id="$route.query.agenda_id"
                      :event_id="$route.query.event_id"
                      :isAgenda="$route.query.isAgenda"
                      :date="$route.query.date"
                      :zw="i5.identity"
                      :headPortrait="
                        i5.image_url
                          ? i5.image_url
                          : 'https://pxsp.iceriverbj.com/default-avatar.png'
                      "
                      :currentDate="$route.query.currentDate"
                      v-for="i5 in i4.guests_data"
                      :key="i5.guest_id + i"
                      :remark="i5.remark"
                      :id="+i5.guest_id" />
                  </div>
                </dl>
                <div
                  v-show="i2.sub_schedule.length !== 1"
                  style="
                    margin-top: 0.2rem;
                    border-bottom: 1px solid rgba(217, 217, 217, 0.8);
                  "></div>
              </dl>
            </template>
            <!-- pc子日程 -->
            <ul v-else class="pcSubAgenda">
              <li v-for="i4 in i2.sub_schedule" :key="i4.id">
                <span class="time">{{ i4.start_time }}-{{ i4.end_time }}</span>
                <span class="theme">{{ i4.agenda_title }}</span>
                <div class="guest">
                  <div
                    class="guestItem"
                    v-for="(i5, index) in i4.guests_data"
                    :key="i5.name + index">
                    <span
                      class="nameBox"
                      @click="
                        $router.push(
                          `/subpages/guestAgenda?agenda_id=${$route.query.agenda_id}&event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${$route.query.currentDate}&id=${i5.guest_id}&mode=list`
                        )
                      ">
                      <span class="name"> {{ i5.name }} </span>
                      <span class="position"> {{ i5.identity }} </span>
                      <span class="remark"> {{ i5.remark }} </span>
                    </span>
                    <span class="company">{{ i5.company }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </ul>
          <!-- 子日程 -->

          <!-- pc子日程 -->
        </dd>
      </dl>
    </div>

    <button
      class="toggleButton"
      v-if="$store.state.agendaConfig.show_type != 3"
      @click="
        $router.push(
          `/?event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${$route.query.currentDate}&listDate=${$route.query.listDate}&listPlace=${$route.query.listPlace}&listGroup=${$route.query.listGroup}`
        )
      ">
      <img src="@/assets/image/mapIcon.png" alt="" />
      地图模式
    </button>
  </div>
</template>

<script>
import { getAgendaConfig, getListmodeAgendaList } from '@/api';
import peopleItem from '../Subpages/components/people-item.vue';

export default {
  name: 'MainAgendaList',
  components: {
    peopleItem,
  },
  data() {
    return {
      // 筛选项目当前选中
      dateSelectedValue: '',
      groupSelectedValue: '',
      placeSelectedValue: '',

      listLoading: false,
      mainLoading: true,

      //   筛选项目长度
      groupUl: '',
      dateUl: '',
      placeUl: '',

      // 日程列表
      agendaList: [],

      // 是否隐藏
      dateSelectedValueHide: false,
      groupSelectedValueHide: false,
      placeSelectedValueHide: false,

      // 隐藏后数据
      dateSelectedValueHideList: '',
      groupSelectedValueHideList: '',
      placeSelectedValueHideList: '',

      hideTimer: '',

      // 日程配置列表
      agendaConfig: {
        agenda_date: [],
        agenda_group: [],
        agenda_place: [],
      },
      initAgendaPlace: [],
      sort_type: '',
      sort_setting: {},
    };
  },

  async created() {
    this.GetAgendaConfig();
    await this.GetListmodeAgendaList(0, 'init');
    this.mainLoading = false;
  },
  mounted() {},
  computed: {
    // 是否为手机端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },

  watch: {
    mainLoading(newvalue) {
      if (!newvalue) {
        this.$nextTick(function () {
          this.initScreenListNum();
        });
      }
    },
  },

  methods: {
    // 筛选点击回调
    screenClick(flag, value) {
      console.log(Boolean(value));
      // if (value) {
      //   const key = this[flag].includes(value);
      //   console.log(key);
      //   if (key) {
      //     this[flag] = this[flag].filter((item) => {
      //       return item != value;
      //     });
      //     this[flag].length
      //       ? this.GetListmodeAgendaList()
      //       : this.GetListmodeAgendaList("all");
      //   } else {
      //     this[flag].push(value);
      //     this.GetListmodeAgendaList();
      //   }
      // } else {
      //   this[flag] = [];
      //   this.GetListmodeAgendaList("all");
      // }
      if (this[flag] == value) return;
      if (value) {
        if (flag == 'dateSelectedValue' && this.sort_type == 3) {
          this.agendaConfig.agenda_place = this.initAgendaPlace;
          this.agendaConfig.agenda_place = JSON.parse(JSON.stringify(this.sort_setting[value]));
        }

        this[flag] = value;
        this.GetListmodeAgendaList();
      } else {
        if (flag == 'dateSelectedValue' && this.sort_type == 3) {
          this.agendaConfig.agenda_place = this.initAgendaPlace;
        }

        this[flag] = '';
        this.GetListmodeAgendaList('all');
      }
    },
    toLive(live_url) {
      window.open(live_url);
    },
    // 收起展开按钮回调
    StowOpenClick(flag, ref) {
      if (!flag) {
        this.$refs[ref].classList.add('stowed');
        this[ref] = 1;
      } else {
        this.$refs[ref].classList.remove('stowed');
        this[ref] = 0;
      }
    },
    // 隐藏按钮
    hideButton(flag) {
      console.log(123);
      this.hideTimer = setTimeout(() => {
        if (this[flag + 'Hide']) {
          this[flag + 'Hide'] = false;
          this[flag + 'HideList'] = [];
          if (flag === 'dateSelectedValue') {
            this.delQuery('listDate');
          } else if (flag === 'groupSelectedValue') {
            this.delQuery('listGroup');
          } else if (flag === 'placeSelectedValue') {
            this.delQuery('listPlace');
          }
        } else {
          if (this[flag].length) {
            if (flag === 'dateSelectedValue') {
              this.addQuery('listDate', this[flag]);
            } else if (flag === 'groupSelectedValue') {
              this.addQuery('listGroup', this[flag]);
            } else if (flag === 'placeSelectedValue') {
              this.addQuery('listPlace', this[flag]);
            }
            this[flag + 'Hide'] = true;
            this[flag + 'HideList'] = this[flag];
          }
        }
      }, 2000);
    },
    up() {
      console.log(456);

      clearTimeout(this.hideTimer);
    },

    // 在地址栏增加参数
    addQuery(keyVal, value) {
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          [keyVal]: JSON.stringify(value),
        },
      });
    },

    // 删除地址栏参数
    delQuery(key) {
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 深拷贝
      delete newQuery[key];
      // 如果有引入 lodash, 可以写成: let newQuery = _.omit(this.$route.query, 'code')
      this.$router.push({ query: newQuery });
    },
    // 检测高度
    initScreenListNum() {
      const h = this.$refs.placeLi.clientHeight;
      if (this.$refs.placeUl.clientHeight > h * 2) {
        this.$refs.placeUl.classList.add('stowed');
        this.placeUl = 1;
      } else {
        this.placeUl = 2;
      }

      const h2 = this.$refs.dateLi.clientHeight;
      if (this.$refs.dateUl.clientHeight > h2 * 2) {
        this.$refs.dateUl.classList.add('stowed');
        this.dateUl = 1;
      } else {
        this.dateUl = 2;
      }

      const h3 = this.$refs.groupLi.clientHeight;
      if (this.$refs.groupUl.clientHeight > h3 * 2) {
        this.$refs.groupUl.classList.add('stowed');
        this.groupUl = 1;
      } else {
        this.groupUl = 2;
      }
    },

    // 获取日程数据
    async GetListmodeAgendaList(key, isInit) {
      this.agendaList = [];
      this.listLoading = true;

      if (isInit) {
        // 如果有日期筛选
        if (this.$route.query.listDate) {
          this.dateSelectedValue = JSON.parse(this.$route.query.listDate);
          console.log(
            '🚀 ~ file: index.vue:526 ~ GetListmodeAgendaList ~ this.dateSelectedValue:',
            this.dateSelectedValue
          );
          console.log(
            '🚀 ~ file: index.vue:526 ~ GetListmodeAgendaList ~ JSON.parse(this.$route.query.listDate):',
            JSON.parse(this.$route.query.listDate)
          );
          this.dateSelectedValueHideList = JSON.parse(this.$route.query.listDate);
          this.dateSelectedValueHide = true;
        }
        // 如果有分组筛选

        if (this.$route.query.listGroup) {
          this.groupSelectedValue = JSON.parse(this.$route.query.listGroup);
          this.groupSelectedValueHideList = JSON.parse(this.$route.query.listGroup);
          this.groupSelectedValueHide = true;
        }
        // 如果有场地筛选
        if (this.$route.query.listPlace) {
          this.placeSelectedValue = JSON.parse(this.$route.query.listPlace);
          this.placeSelectedValueHideList = JSON.parse(this.$route.query.listPlace);
          this.placeSelectedValueHide = true;
        }
      }

      const { data } = await getListmodeAgendaList({
        sub_schedule: 1,
        event_id: this.$route.query.event_id,
        agenda_date:
          (key === 'all' && this.dateSelectedValueHide) ||
          (this.dateSelectedValueHide && this.dateSelectedValue == '')
            ? this.dateSelectedValueHideList
            : this.dateSelectedValue,
        agenda_group:
          (key === 'all' && this.groupSelectedValueHide) ||
          (this.groupSelectedValueHide && this.groupSelectedValue == '')
            ? this.groupSelectedValueHideList
            : this.groupSelectedValue,
        agenda_place:
          (key === 'all' && this.placeSelectedValueHide) ||
          (this.placeSelectedValueHide && this.placeSelectedValue == '')
            ? this.placeSelectedValueHideList
            : this.placeSelectedValue,
        id: '',
      });

      // 只筛选有日程的日期
      data.data.result = data.data.result.filter((item) => {
        item.Agendas = item.Agendas.filter((i) => {
          return i.Agendas.length;
        });
        if (item.Agendas.length) {
          return true;
        }
      });

      // 处理嘉宾
      data.data.result.forEach((item) => {
        item.Agendas.forEach((i) => {
          i.Agendas.forEach((i2) => {
            i2.guests_data = this.produceNewArray(i2.guests_data);
          });
        });
      });

      this.agendaList = data.data.result;
      this.listLoading = false;
      if (isInit) {
        this.dateSelectedValue = '';
        this.groupSelectedValue = '';
        this.placeSelectedValue = '';
      }
    },

    // 获取日程配置
    async GetAgendaConfig() {
      const { data } = await getAgendaConfig(this.$route.query.event_id);
      this.initAgendaPlace = data.data.agenda_place;
      this.sort_setting = data.data.sort_setting;
      this.sort_type = data.data.sort_type;
      Object.keys(data.data.agenda_date).forEach((key) => {
        this.agendaConfig.agenda_date.push(data.data.agenda_date[key]);
      });

      Object.keys(data.data.agenda_group).forEach((key) => {
        this.agendaConfig.agenda_group.push(data.data.agenda_group[key]);
      });

      Object.keys(data.data.agenda_place).forEach((key) => {
        this.agendaConfig.agenda_place.push(data.data.agenda_place[key]);
      });
    },

    // 处理嘉宾数据
    produceNewArray(arr) {
      let newArr = [];
      arr &&
        arr.forEach((item, i) => {
          let index = -1;
          let identity = newArr.some((newItem, j) => {
            if (item.identity === newItem.identity) {
              index = j;
              return true;
            }
          });
          if (!identity) {
            newArr.push({
              identity: item.identity,
              childrenList: [
                {
                  name: item.name,
                  guest_id: item.guest_id,
                  company: item.company,
                  identity: item.identity,
                  image_url: item.image_url,
                },
              ],
            });
          } else {
            newArr[index].childrenList.push({
              name: item.name,
              guest_id: item.guest_id,
              company: item.company,
              identity: item.identity,
              image_url: item.image_url,
            });
          }
        });
      return newArr;
    },
  },
};
</script>

<style lang="scss" scoped>
span,
div {
  font-size: 0.35rem;
}

.MainAgendaList {
  padding-bottom: 1rem;
  -webkit-text-size-adjust: none;
}
.stowed {
  max-height: 1.4rem;
  overflow: hidden;
}
.buttonBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.2rem 4%;

  a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.4rem;
    box-sizing: border-box;
    height: 0.8rem;
    background: #409eff;
    width: 48%;
    border: 1px solid #409eff;
    border-radius: 7px;

    span {
      font-size: 0.4rem;
      color: #ffffff;
      opacity: 0.5;
    }
    img {
      height: 60%;
    }
  }
}

.screenBox {
  padding: 0.2rem 4%;
  .screenItem {
    position: relative;
    display: flex;
    font-size: 0.4rem;

    &:nth-of-type(n + 2) {
      margin-top: 1rem;
    }
    .name {
      width: 0.9rem;
      font-size: 0.4rem;
      font-weight: 700;
    }
    ul {
      width: 100%;
      li {
        box-sizing: border-box;
        padding: 0 0.1rem;
        color: #949494;
        display: inline-block;
        margin-left: 0.4rem;
        text-align: left;
        cursor: pointer;
        line-height: 0.7rem;
      }

      .Selected {
        background-color: #409eff;
        color: #fff;
        border-radius: 9px;
      }
    }

    div {
      color: #409eff;
      font-size: 0.4rem;
      position: absolute;
      bottom: -0.6rem;
      left: 1.3rem;
      cursor: pointer;
    }
  }
}

.scheduleListBox {
  padding: 0.2rem 4%;

  .date {
    font-size: 0.4rem;
    text-align: center;
  }
  .place {
    font-size: 0.4rem;
    margin-top: 0.5rem;
  }

  .mainSchedule {
    > li {
      position: relative;
      color: #ffffff;
      padding: 0.2rem 0.4rem;
      margin-top: 0.2rem;
      background: #409eff;
      border-radius: 3px;

      .toLive-btn {
        cursor: pointer;
        position: absolute;
        display: flex;
        right: 4%;
        top: 10%;
        width: 1.5rem;
        height: 0.5rem;
        background: #ffffff;
        border-radius: 5px;
        align-items: center;
        justify-content: center;

        .toLiveText {
          margin-left: 0.1rem;
          font-size: 0.2rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #409eff;
        }
      }

      .left-top {
        display: flex;
        align-items: center;
        line-height: 100%;

        .theme {
          flex: 8;
          vertical-align: top;
        }
      }
      .left-bottom {
        li {
          display: flex;
          margin-top: 0.2rem;
          .title {
            margin-top: 0.1rem;
            white-space: nowrap;
          }
          .guestList {
            margin-left: 0.1rem;
            .guest {
              cursor: pointer;
              &:nth-child(1) {
                margin-left: 0 !important;
              }
              margin-top: 0.1rem;
              display: flex;
            }
          }
        }
      }
    }
  }

  .subAgenda {
    padding: 0.2rem 0.4rem;
    padding-bottom: 0;
    dt {
      margin-left: 0.2rem;

      .theme {
        margin-top: 0.1rem;
      }
    }
  }
  .pcSubAgenda {
    li {
      padding: 1%;
      border-bottom: 1px solid rgba(217, 217, 217, 0.8);
      display: grid;
      grid-template-columns: 11% 35% 54%;
      .guest {
        .guestItem {
          display: flex;
          justify-content: space-between;
          .nameBox {
            cursor: pointer;
            flex: 3;
            padding-right: 0.2rem;
            .name {
              font-size: 0.3rem;
            }
            .position {
              margin-left: 0.05rem;
              line-height: 0.3rem;
              text-align: center;
              padding: 0 0.1rem;
              border: 1px solid #409eff;
              color: #409eff;
              border-radius: 12px;
              font-size: 0.2rem;
            }
          }

          &:nth-of-type(n + 2) {
            .company {
              margin-top: 3px;
            }
            .name {
              margin-top: 3px;
            }
          }
          .company {
            flex: 3;
          }
        }
      }
    }
  }
}

.splitLine {
  height: 1px;
  width: 97%;
  margin: 0.8rem auto;
  background-color: #409eff;
  margin-bottom: 0;
}

.people {
  padding-left: 0.2rem;

  ::v-deep .host-item {
    margin-top: 1px;
  }
  ::v-deep .name {
    font-size: 0.35rem !important;
  }
  ::v-deep .right .position {
    font-size: 0.3rem !important;
  }
  ::v-deep .van-image {
    width: 1rem !important;
    height: 1rem !important;
  }

  ::v-deep .host-item .right span:nth-child(1) .zwBox .zw {
    color: #409eff;
    font-size: 0.25rem;
  }
}

.toggleButton {
  cursor: pointer;
  position: fixed;
  bottom: 0;
  margin-top: 1rem;
  padding: 0.2rem 0;
  width: 100%;
  background: #efefef;
  border: 0px solid #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #949494;
  font-size: 0.4rem;
  img {
    width: 0.4rem;
  }
}
.listLoading {
  text-align: center;
}
.mainLoading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.remark {
    font-size: .25rem;
    margin-left: .1rem;
    color: #acaaaa;
    line-height: 100%;
}
</style>
